import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { SET_MAIN_LOADER } from '../../redux/loaderSlice';

export let RePrintData = (place_bet, dispatch) => {
  let { card_details, mobile_number, is_advance } = place_bet;

  if (mobile_number) {
    // console.log("Mobile number present, skipping print...");
    dispatch(SET_MAIN_LOADER(false));
    return;
  }

  let PrintObj = {};
  Object.keys(card_details).map((key) => {
    let x = PrintObj[key.charAt(0)]?.totalValue || 0;
    let value = Number(card_details[key]);
    if (PrintObj[key.charAt(0)]) {
      PrintObj[key.charAt(0)].totalCount += 1;
      PrintObj[key.charAt(0)].totalValue +=
        Number(value) === x && x % 1 !== 0
          ? (value * 10 + 0.1 * 10) / 10
          : value;
      PrintObj[key.charAt(0)].seriesAllfield = [
        ...PrintObj[key.charAt(0)].seriesAllfield,
        { name: key, value: card_details[key] },
      ];
    } else {
      PrintObj[key.charAt(0)] = {
        totalCount: 1,
        totalValue:
          Number(value) === x && x % 1 !== 0
            ? (value * 10 + 0.1 * 10) / 10
            : value,
        multiply: 2,
        seriesAllfield: [{ name: key, value: card_details[key] }],
      };
    }
  });

  // default bet_details if missing
  if (place_bet && !place_bet?.bet_details) {
    place_bet.bet_details = [
      {
        deal_date: place_bet?.deal_date,
        deal_time: place_bet?.deal_time,
        ticket_id: place_bet?.ticket_id,
      },
    ];
  }

  // 🟢 NEW LOGIC
  if (place_bet?.bet_details && is_advance) {
    // 🧩 Merge all bets in one page
    let renderData = "";
    place_bet.bet_details.forEach((betDetail, betIndex) => {
      renderData += ReactDOMServer.renderToString(
        <PrintComponet1
          detail={betDetail}
          LOTTERY_PLACE_BET={place_bet}
          key={`h${betIndex}`}
        />
      );
      renderData += ReactDOMServer.renderToString(
        <PrintComponet2
          printObj={PrintObj}
          LOTTERY_PLACE_BET={place_bet}
          key={`b${betIndex}`}
          betDetail={betDetail}
        />
      );
      renderData += "<hr />";
    });

    // 🧩 open only one print window
    try {
      let x = window.open("", "_blank");
      if (x) {
        x.document.open();
        x.document.write(`
          <html>
            <head>
              <title>Advance Print</title>
              <style>
                body { font-family: 'Roboto', sans-serif; color: #000; font-weight: bold; } 
                .printArea { margin-left: 10px; font-size: 12px; font-weight: bold; color: black; } 
                .printArea p { margin: 0px; font-weight: bold; } 
                .serizContainer { display: flex; flex-wrap: wrap; width: 100%; justify-content: flex-start; } 
                .sirizList, .valContent { display: flex; font-weight: bold; font-size: 12px; justify-content: space-between; } 
                hr { margin-block-start: 0.1em; margin-block-end: 0.1em; } 
                @media print { @page { margin: 0 auto; margin-top: 0.5cm; size: 80mm auto; } 
                body { margin: 0 auto; } }
              </style>
              <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.5/dist/JsBarcode.all.min.js"></script>
            </head>
            <body>
              <div class="printArea" style="width: 50mm">
                ${renderData}
              </div>
              <script>
                window.onload = function() {
                  let ticketIDArray = document.querySelectorAll('.ticketId');
                  ticketIDArray.forEach(element => {
                    let ticketId = element.innerHTML.trim();
                    JsBarcode('#barcode' + ticketId, ticketId, {
                      width: 1,
                      height: 40,
                      displayValue: false,
                      marginBottom: 20
                    });
                  });
                  setTimeout(() => {
                    window.print();
                    window.close();
                  }, 500);
                }
              </script>
            </body>
          </html>
        `);
        x.document.close();
      }
    } catch (error) {
      console.error("Error while printing advance:", error);
    } finally {
      dispatch(SET_MAIN_LOADER(false));
    }

  } else if (place_bet?.bet_details) {
    // 🧩 normal printing (each ticket separate)
    place_bet.bet_details.forEach((betDetail, betIndex) => {
      let renderData = "";
      renderData += ReactDOMServer.renderToString(
        <PrintComponet1
          detail={betDetail}
          LOTTERY_PLACE_BET={place_bet}
          key={betIndex}
        />
      );
      renderData += ReactDOMServer.renderToString(
        <PrintComponet2
          printObj={PrintObj}
          LOTTERY_PLACE_BET={place_bet}
          key={betIndex}
          betDetail={betDetail}
        />
      );

      setTimeout(() => {
        try {
          let x = window.open("", "_blank");
          if (x) {
            x.document.open();
            x.document.write(`
              <html>
                <head>
                  <title>Print it!</title> 
                  <style>
                    body { font-family: 'Roboto', sans-serif; color: #000; font-weight: bold; } 
                    .printArea { margin-left: 10px; font-size: 12px; font-weight: bold; color: black; } 
                    .printArea p { margin: 0px; font-weight: bold; } 
                    .serizContainer { display: flex; flex-wrap: wrap; width: 100%; justify-content: flex-start; } 
                    .sirizList, .valContent { display: flex; font-weight: bold; font-size: 12px; justify-content: space-between; } 
                    hr { margin-block-start: 0.1em; margin-block-end: 0.1em; } 
                    @media print { @page { margin: 0 auto; margin-top: 0.5cm; size: 80mm auto; } body { margin: 0 auto; } }
                  </style>
                  <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.5/dist/JsBarcode.all.min.js"></script>
                </head>
                <body>
                  <div class="printArea" style="width: 50mm">
                    ${renderData}
                  </div>
                  <script>
                    window.onload = function() {
                      let ticketIDArray = document.querySelectorAll('.ticketId');
                      ticketIDArray.forEach(element => {
                        let ticketId = element.innerHTML.trim();
                        JsBarcode('#barcode' + ticketId, ticketId, {
                          width: 1,
                          height: 40,
                          displayValue: false,
                          marginBottom: 20
                        });
                      });
                      setTimeout(() => {
                        window.print();
                        window.close();
                      }, 500);
                    }
                  </script>
                </body>
              </html>
            `);
            x.document.close();
          }
        } catch (error) {
          console.error("Error while printing:", error);
        } finally {
          dispatch(SET_MAIN_LOADER(false));
        }
      }, 1000);
    });
  }
};


// -------- Component 1 --------
const PrintComponet1 = ({ detail, LOTTERY_PLACE_BET }) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", fontWeight: "bold" }}>
      <p>
         4D <br />
        For Amusement Only <br />
        Reprint Ticket <br />
        Agent ID : {LOTTERY_PLACE_BET?.user_name} <br />
        Ticket ID : <span style={{ fontSize: "14px" }}>{detail.ticket_id}</span> <br />
        Coupen Dr Time : {detail.deal_date} <br />
        Coupen Time : {detail.deal_time} <br />
        Total Point : <span style={{ fontSize: "13px" }}>{Math.floor(LOTTERY_PLACE_BET?.total_bet_amount)}</span>
      </p>
      <br />
    </div>
  );
};


// -------- Component 2 --------
const PrintComponet2 = ({ LOTTERY_PLACE_BET, printObj, betDetail }) => {
  return (
    <>
      {Object.keys(printObj).map((ab, abindex) => (
        <React.Fragment key={abindex}>
          <div className="serizContainer">
            {printObj[ab].seriesAllfield.map((value, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  fontSize: "12px",
                }}
              >
                <p>{value.name}</p> &nbsp; 
                <span style={{ fontWeight: "bold", fontSize: "14px" }}>*</span> &nbsp;
                <p>{value.value / 2}</p> &nbsp;&nbsp;
              </div>
            ))}
          </div>

          <div
            className="valRow"
            style={{
              fontWeight: "bold",
              fontSize: "10px",
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div className="valContent"><p>Val : 2</p></div>
            <div className="valContent"><p>Qty : {printObj[ab].totalCount}</p></div>
            <div className="valContent"><p>Total : {Math.floor(printObj[ab].totalValue)}</p></div>
          </div>
        </React.Fragment>
      ))}

      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
        <svg id={`barcode` + betDetail?.ticket_id}></svg>
        <p className="ticketId" style={{ marginTop: 0, textAlign: "center", fontWeight: "bold", fontSize: "14px" }}>
          {betDetail?.ticket_id}
        </p>
      </div>
    </>
  );
};
